/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OUSTIDE_CLICK_DIRECTIVES } from "./index";
var ClrOutsideClickModule = (function () {
    function ClrOutsideClickModule() {
    }
    return ClrOutsideClickModule;
}());
export { ClrOutsideClickModule };
ClrOutsideClickModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [OUSTIDE_CLICK_DIRECTIVES],
                exports: [OUSTIDE_CLICK_DIRECTIVES]
            },] },
];
/** @nocollapse */
ClrOutsideClickModule.ctorParameters = function () { return []; };
//# sourceMappingURL=outside-click.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/utils/outside-click/outside-click.module.js
// module id = 314
// module chunks = 4